import React, { useState, useEffect, useRef } from "react";
import { mediaData } from "../data/mediaData";
import config from "../data/config";
import { motion } from "framer-motion";
import { storyChangeAnimSlide, wrapperAnim, childAnim } from "../data/common";

const SplashStartWrapper = ({
  showStartScreen,
  splashListData,
  setShowStartScreen,
  storyChangeHandler,
  callGaHandler,
  currStoryId,
}) => {
  const [splashStartData, setSplashStartData] = useState({});
  const [splashMediaUrl, setSplashMediaUrl] = useState("");
  const [splashContent, setSplashContent] = useState([]);
  const videoRef = useRef(undefined);
  useEffect(() => {
    if (splashListData && splashListData.length) {
      let tempSplashData = [];
      tempSplashData = splashListData.filter((val) => {
        return val.splash_type === "start";
      });
      setSplashStartData(tempSplashData[0]);
    }
  }, [splashListData]);

  useEffect(() => {
    if (splashStartData && Object.keys(splashStartData).length) {
      setSplashMediaUrl(splashStartData.splash_media_url);
      setSplashContent(splashStartData.splash_content);
    }
  }, [splashStartData]);

  useEffect(() => {
    if (splashMediaUrl !== "") {
      videoRef.current.defaultMuted = true;
      if (showStartScreen) {
        videoRef.current.play();
        videoRef.current.currentTime = 0;
      } else {
        videoRef.current.pause();
      }
    }
  }, [splashMediaUrl]);

  const onTouchEnd = () => {
    setShowStartScreen(false);
    storyChangeHandler(currStoryId, false);
    callGaHandler("Traffic", "Story_page");
    callGaHandler("Swipe", "Swiped_successfully");
  };

  return (
    <motion.div
      className="main-swiper-wrapper main-swiper-wrapper-splash"
      onTouchEnd={onTouchEnd}
      onMouseUp={onTouchEnd}
      variants={storyChangeAnimSlide}
      initial="initial"
      animate="active"
      exit="exit"
    >
      <div className="splash-video-block">
        <div className="one3d-splash-screen-main-title">
          <span>Curvv.ev</span> <i><b>suv</b> coupé</i>
        </div>

        {splashMediaUrl !== "" && splashContent && splashContent.length ? (
          <>
            <video
              preload="true"
              muted
              autoPlay
              playsInline
              disablePictureInPicture
              ref={videoRef}
              poster={mediaData["videoPoster"]}
            >
              <source
                src={`${config.BUCKET_URL}${splashMediaUrl}`}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            <motion.div
              className="splash-content-wrapper splash-content-start splash-content-start-new"
              variants={wrapperAnim}
              initial="initial"
              animate="animate"
            >
              <motion.div
                className="splash-text-wrapper mt-4"
                variants={childAnim}
              >
                {/* <div className="splash-small-text">
                  {splashStartData?.splash_content[0]}
                </div>
                <div className="splash-title">
                  {splashStartData?.splash_content[1]}
                </div> */}
              </motion.div>

              <motion.div className="splash-text-wrapper" variants={childAnim}>
                <div className="splash-small-text">
                  {splashStartData?.splash_content[2]}
                </div>
                <div className="splash-sub-title">
                  <h4>
                    {splashStartData?.splash_content[3]}<span>{splashStartData?.splash_content[4]}</span>
                  </h4>
                </div>
              </motion.div>

              <motion.div
                className="splash-swipe-left-btn"
                variants={childAnim}
              >
                <div className="flex flex-col justify-center items-center">
                  <img src={mediaData["swipeAnimation"]} alt="" />
                  <div className="swipe-text">Swipe left to explore</div>
                </div>
              </motion.div>
            </motion.div>
          </>
        ) : null}
      </div>
    </motion.div>
  );
};

export default SplashStartWrapper;
